(function () {
    const menuTitles = document.querySelectorAll('.menu_mobile .header_menu_item div.header_menu_link')

    menuTitles.forEach(element => {
      element.addEventListener('click', () => {
        const triggerList = () => {
          const hideAccordions = () => {
            menuTitles.forEach(element2 => {
              element2.parentElement.classList.remove('open')
              element2.nextElementSibling.classList.remove('open');
              element2.nextElementSibling.style.maxHeight = 0;
            })     
          }
          
  
          if (element.parentElement.classList.contains('open')) {
            if (!element.closest('.no-hide')) {
              hideAccordions()
            }   
            element.nextElementSibling.classList.remove('open');
            element.parentElement.classList.remove('open');
            element.nextElementSibling.style.maxHeight = 0;
          } else {
            if (!element.closest('.no-hide')) {
              hideAccordions()
            }
  
            element.parentElement.classList.add('open');
            element.nextElementSibling.classList.add('open');
            element.nextElementSibling.style.maxHeight = element.nextElementSibling.scrollHeight + 'px'; 
          }
        }
        triggerList()
        
      })
    });
})();

// product gallery slider
(function () {
  if (document.body.classList.contains('template-product')) {
    const gallery = new Swiper('.single-left-slider', {
      
    });
  }
})();
// product gallery slider

(function () {
    if (document.body.classList.contains('template-product')) {
        
        // const player0 = MusePlayer({
        //     container: '.muse-video-player-1',
        //     video: window.socialVideos[0],
        //     search: false,
        //     links: false,
        //     logo: false,
        //     title: false,
        //     autoplay: true,
        //     loop: true,
        //     volume: 0,
        //     style: "no-controls",
        //     width: '100%'
        // });
        

        // const players = [player0, player1, player2, player3, player4]

        // const sliderSocial = new Swiper('.slider_social__slider', {
        //     autoplay: {
        //       delay: 5000,
        //     },
        //     pagination: {
        //         el: '.swiper-pagination',
        //     },
        //     navigation: {
        //         nextEl: '.swiper-button-next',
        //         prevEl: '.swiper-button-prev',
        //     },
        //     on: {
        //         slideChange: function (swiper) {
                    
        //             players.forEach(player => {
                        
        //                 player.seek(0)
        //             });
        //             // console.log(players[swiper.activeIndex].play())
        //             players[swiper.activeIndex].play()
        //         },
        //     },
        // });

        
    }
})();

// play video
(function () {
  const playVideo = document.querySelectorAll('.play_btn');

  playVideo.forEach(element => {
    element.addEventListener('click', () => {
      const video = element.closest('.video_wr').querySelector('video');
      if (video.paused) {
        video.play();
        video.controls = true;
        element.remove();
      }
    });
  });
})();
// play video